import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FC } from 'react';

import { Card, Chip } from '@servicetitan/anvil2';
import { core } from '@servicetitan/anvil2/token';

import { TitleValue, TitleWithValueComponent } from './common/title-value';
import { AirflowDiagnosticsResponseDataDto } from '../../models/airflow-diagnostics.response.dto';

export const AirflowDiagnosticsAnswer: FC<{
    data: AirflowDiagnosticsResponseDataDto;
    className?: string;
}> = observer(({ data, className }) => {
    const chipColor =
        data.result.status === 'red'
            ? core.primitive.ColorRed100.value
            : data.result.status === 'yellow'
              ? core.primitive.ColorYellow100.value
              : core.primitive.ColorGreen100.value;

    const chipLabel = data.result.title;

    return (
        <Card className={classNames('w-100-i', className)}>
            <div
                style={{
                    flexGrow: '1',
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    rowGap: 12,
                }}
            >
                <TitleValue title="nominal cfm" value={data.cfm.nominal} />
                <TitleValue title="estimated cfm" value={data.cfm.estimated} />
                <TitleValue title="Airflow" value={`${Number(data.result.airflow).toFixed(0)}%`} />
                <TitleWithValueComponent
                    title="Status"
                    value={<Chip size="small" color={chipColor} label={chipLabel} />}
                />
                <div style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
                    <TitleValue title="description" value={data.result.description} />
                </div>
            </div>
        </Card>
    );
});
